import React from "react";
import PropTypes from "prop-types";
import Checkbox from "./Checkbox";
import "./StatusFilter.css";

const StatusFilter = ({ isSelling = false, condition = "", onChange }) => {
  const handleIsSellingChange = () => {
    onChange({ isSelling: !isSelling, condition });
  };

  const handleConditionChange = () => {
    onChange({ isSelling, condition: condition === "NEW" ? "" : "NEW" });
  };

  return (
    <div className="status-filter-container">
      <Checkbox
        id="is-selling"
        text="품절 상품 제외"
        checked={isSelling}
        onChange={handleIsSellingChange}
      />
      <Checkbox
        id="is-new"
        text="새상품만 보기"
        checked={condition === "NEW"}
        onChange={handleConditionChange}
      />
    </div>
  );
};

StatusFilter.propTypes = {
  isSelling: PropTypes.bool,
  condition: PropTypes.string,
  onChange: PropTypes.func.isRequired,
};

export default StatusFilter;
